/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Custom styles for the SidenavCollapse
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import { Link, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { List } from "@mui/material";
import MDTypography from "components/MDTypography";

function SidenavCollapse({
  icon,
  name,
  active,
  dropdown,
  dropdownItems,
  ...rest
}) {
  const [controller] = useMaterialUIController();
  const [showItems, setShowItems] = useState(false);
  const location = useLocation();
  const collapseName = location.pathname.replace("/", "").split("/")[1];
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  const renderRoutes = dropdownItems?.map(
    ({
      type,
      name,
      icon,
      title,
      dropdown,
      dropdownItems,
      noCollapse,
      key,
      href,
      route,
      showInSidebar,
    }) => {
      let returnValue;
      if (showInSidebar) {
        if (type === "collapse") {
          returnValue = href ? (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none", paddingRight: 10 }}
              onClick={()=>setShowItems(true)}
            >
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          ) : (
            <NavLink key={key} to={route}>
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                onClick={()=>setShowItems(true)}
              />
            </NavLink>
          );
        }
      }

      return returnValue;
    }
  );
  return (
    <MDBox>
      <ListItem component="li" >
        <MDBox
          {...rest}
          sx={(theme) =>
            collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              sidenavColor,
            })
          }
        >
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, {
                transparentSidenav,
                whiteSidenav,
                darkMode,
                active,
              })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>
                {icon}
              </Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                active,
              })
            }
          />
          {dropdown ? (
            <>
              <ListItemIcon
                sx={(theme) =>
                  collapseIconBox(theme, {
                    transparentSidenav,
                    whiteSidenav,
                    darkMode,
                    active,
                  })
                }
                onClick={(e)=>{
                  e.preventDefault();
                  if(showItems){
                    setShowItems(false);
                  }else{
                    setShowItems(true);
                  }
                }}
                
              >
                {showItems ? (
                  <Icon>keyboard_arrow_down</Icon>
                ) : (
                  <Icon>keyboard_arrow_right</Icon>
                )}
              </ListItemIcon>
            </>
          ) : (
            <></>
          )}
        </MDBox>
        
      </ListItem>
      {showItems ? (
        <List sx={{ paddingLeft: 2 }}>{renderRoutes}
        
        </List>
      ) : (
        <></>
      )}

      
    </MDBox>
  );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
  active: false,
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavCollapse;
